/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Project_References_BlurbInputs */



/**
* | output |
* | --- |
* | "Files and spaces attached to the project are available in every chat here, so your whole team draws on the same knowledge base." |
*
* @param {Uno_Edu_Project_References_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_project_references_blurb = /** @type {((inputs?: Uno_Edu_Project_References_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Project_References_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateien und Spaces, die dem Projekt angehängt sind, stehen in jedem Chat hier zur Verfügung, sodass Ihr gesamtes Team auf dieselbe Wissensbasis zugreift.")
	return /** @type {LocalizedString} */ ("Files and spaces attached to the project are available in every chat here, so your whole team draws on the same knowledge base.")
});